var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_008-cube",
    "data-name": "008-cube",
    transform: "translate(-30 -30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M76.4,30H31.6A1.6,1.6,0,0,0,30,31.6V76.4A1.6,1.6,0,0,0,31.6,78H52.4V74.8H33.2v-32H74.8v9.6H78V31.6A1.6,1.6,0,0,0,76.4,30ZM33.2,39.6V33.2H74.8v6.4Z",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M54,54h3.2v3.2H54Z",
    transform: "translate(-19.2 -19.2)",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M78,54h3.2v3.2H78Z",
    transform: "translate(-38.4 -19.2)",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M102,54h3.2v3.2H102Z",
    transform: "translate(-57.6 -19.2)",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M167.584,148.179c0-.024-.009-.047-.013-.071-.009-.048-.019-.1-.032-.143-.008-.027-.016-.053-.025-.079-.014-.043-.03-.085-.048-.126-.011-.026-.023-.051-.035-.076-.021-.041-.043-.081-.067-.12-.014-.022-.026-.045-.041-.066-.03-.044-.062-.085-.1-.125-.012-.015-.023-.03-.036-.045a1.621,1.621,0,0,0-.154-.15c-.014-.012-.03-.022-.044-.033-.036-.028-.071-.057-.11-.083l-.022-.012c-.022-.014-.046-.027-.069-.04-.041-.024-.083-.046-.126-.066-.011-.005-.022-.012-.033-.017l-11.2-4.8a1.6,1.6,0,0,0-1.261,0l-11.2,4.8A1.6,1.6,0,0,0,142,148.4v12.8a1.6,1.6,0,0,0,.97,1.471l11.2,4.8a1.623,1.623,0,0,0,.166.06l.034.009a1.579,1.579,0,0,0,.171.038l.054.008a1.6,1.6,0,0,0,.205.015h0a1.606,1.606,0,0,0,.205-.015l.054-.008a1.6,1.6,0,0,0,.171-.038l.033-.009a1.644,1.644,0,0,0,.166-.06l11.2-4.8a1.6,1.6,0,0,0,.97-1.471V148.4a1.605,1.605,0,0,0-.016-.22ZM154.8,145.339l7.138,3.059-7.138,3.059-7.138-3.059Zm-9.6,5.486,8,3.429v9.318l-8-3.429Zm11.2,12.747v-9.319l8-3.429v9.318Z",
    transform: "translate(-89.6 -89.599)",
    fill: "#051ee1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5);
export default __webpack_public_path__ + "static/media/feature_5.7d96012400cadaf3f7780653cec59e29.svg";
export { ForwardRef as ReactComponent };